window.addEventListener('load', () => {});

customElements.define('ec-cpm-cylindo', class extends HTMLElement {
  constructor() {
    super();
    this.viewerEl = null;
    this.thumbnailEl = null;

    this.handleFullscreen = this.handleFullscreen.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
  }

  connectedCallback() {
    this.viewerEl = this.querySelector('cylindo-viewer');
    if(!this.viewerEl) return;

    this.thumbnailEl = document.getElementById("cylindo-thumb");

    if (this.getAttribute('data-section-id').trim()) {
      document.addEventListener(`${this.getAttribute('data-section-id')}-completed`, this.handleUpdate);
      document.addEventListener(`${this.getAttribute('data-section-id')}-update`, this.handleUpdate);
    }

    this.viewerEl.addEventListener('fullscreen-change', this.handleFullscreen);
  }

  disconnectedCallback() {
    if (this.viewerEl) {
      this.viewerEl.removeEventListener('fullscreen-change', this.handleFullscreen);
    }
  }

  handleFullscreen(e) {
    this.classList.toggle('fullscreen', e.detail.isFullscreen);
  }

handleUpdate(e) {
  if (!e.detail || !e.detail.state?.cylindo || !Object.keys(e.detail.state?.cylindo).length) return;
  const detail = e.detail;
  const newCylindoId = detail.state?.variant?.custom?.default_cylindo_id?.trim() ?? window.shopify_product[0]?.default_cylindo_id?.trim();

  this.viewerEl.features = {
    ...this.viewerEl.features,
    ...detail.state?.cylindo
  };

  if (this.thumbnailEl) {
    this.thumbnailEl.parentElement.classList.remove('hidden');

    const image = this.thumbnailEl.querySelector('img');
    if (image) {
      const src = image.getAttribute('src');
      const url = new URL(src);
      const baseUrl = `${url.origin}${url.pathname}`;

      // Replace product ID in the path
      const updatedPath = baseUrl.replace(/\/products\/\d+\//, `/products/${newCylindoId}/`);

      const features = detail.state?.cylindo;
      const otherParams = [];

      const originalParams = new URLSearchParams(url.search);
      for (const [key, value] of originalParams) {
        if (key !== 'feature') {
          otherParams.push(`${key}=${value}`);
        }
      }

      // Start constructing new src
      let newSrc = updatedPath;
      let separator = '?';

      if (features) {
        for (const key in features) {
          if (features.hasOwnProperty(key)) {
            newSrc += `${separator}feature=${key}:${features[key]}`;
            separator = '&';
          }
        }
      }

      if (otherParams.length > 0) {
        newSrc += `${separator}${otherParams.join('&')}`;
      }

      image.setAttribute('src', newSrc);
    }
  }

  if(e.type.includes('update')) return;

  if (newCylindoId !== '' && newCylindoId !== this.viewerEl?.getAttribute('code')) {
    this.viewerEl?.setAttribute('code', newCylindoId);
  }

  this.classList.remove('hidden');
}
});